module.exports = __webpack_public_path__ + "img/qbc-pricing.6b5f8565.png";